export const SESSION_CACHE_KEY = 'session:query';
export const USER_CACHE_KEY = 'user:query';
